export {
    ATTR_COLOR,
    ATTR_BGCOLOR,
    DATA_OG_STYLE_COLOR,
    DATA_OG_ATTR_COLOR,
    DATA_OG_STYLE_BACKGROUNDCOLOR,
    DATA_OG_ATTR_BGCOLOR,
    ElementColors,
    getElementColors,
    getElementOgColors,
    setElementOgColorsIfUnset,
    setElementColors,
} from './ElementColors';
export { handleOnCopy } from './handleOnCopy';
